// event sources
export const AREASERIES_EVENT_SOURCE = 'AREASERIES_EVENT_SOURCE';
export const AREASTACK_EVENT_SOURCE = 'AREASTACK_EVENT_SOURCE';
export const BARGROUP_EVENT_SOURCE = 'BARGROUP_EVENT_SOURCE';
export const BARSERIES_EVENT_SOURCE = 'BARSERIES_EVENT_SOURCE';
export const BARSTACK_EVENT_SOURCE = 'BARSTACK_EVENT_SOURCE';
export const GLYPHSERIES_EVENT_SOURCE = 'GLYPHSERIES_EVENT_SOURCE';
export const LINESERIES_EVENT_SOURCE = 'LINESERIES_EVENT_SOURCE';
export const XYCHART_EVENT_SOURCE = 'XYCHART_EVENT_SOURCE';